import api from '@/utils/api';

/**
 * Bulk Update Company pricing
 * @param {string} id Company id
 * @param {object} importData - The import price data
 * @returns {Promise}
 */
const bulkUpdatePriceList = (id, importData) =>
  api.patch(`/company/${id}/price/bulk-update`, importData);

export default bulkUpdatePriceList;
